import { createTransform } from "redux-persist";

const BASE64_DATA_URI_REGEX = /^data:.*;base64,/;
const SENSITIVE_KEYS = new Set(["base64Content", "frontBase64", "backBase64"]);

const stripSensitiveImageData = (value) => {
  if (Array.isArray(value)) {
    return value.map(stripSensitiveImageData);
  }
  if (value && typeof value === "object") {
    const result = {};
    for (const [key, val] of Object.entries(value)) {
      if (SENSITIVE_KEYS.has(key) || (typeof val === "string" && BASE64_DATA_URI_REGEX.test(val))) {
        result[key] = null;
        continue;
      }
      result[key] = stripSensitiveImageData(val);
    }
    return result;
  }
  return value;
};

export const stripSensitiveDocumentDataTransform = createTransform(
  (inboundState) => stripSensitiveImageData(inboundState),
  (outboundState) => outboundState,
  { whitelist: ["companyAdmin", "Employee"] }
);
